import ToolMenu from '@/features/tool/components/ToolMenu';

const NavbarToolMenu = () => {
  return (
    <div className="rounded-extra-lg">
      <ToolMenu />
    </div>
  );
};

export default NavbarToolMenu;
